import {
  IonButton,
  IonCol,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonRow,
} from "@ionic/react";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { UserRegistrtionInputFirstControls } from "../UserRegistration.models";
import { useTranslation } from "react-i18next";
import "./UserRegistrationInputFirst.scss";
import { utilService } from "../../../services";

const UserRegistrationInputFirst: React.FC<
  UserRegistrtionInputFirstControls
> = (props) => {
  const [isShowPassword, setPasswordStatus] = useState(false);
  const [isShowCrfmPassword, setCrfmPasswordStatus] = useState(false);
const { t } = useTranslation("settings");
  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  const onShowCrfmPassword = () => {
    setCrfmPasswordStatus(!isShowCrfmPassword);
  };

  const loadUserDetilsInit = () => {
    props.inputs.firstName.current!.value = props.inputData.firstName;
    props.inputs.lastName.current!.value = props.inputData.lastName;
    props.inputs.displayName.current!.value = props.inputData.displayName;
    props.inputs.userName.current!.value = props.inputData.userName;
    if (props.isPasswordActive) {
      props.inputs.password.current!.value = props.inputData.password;
      props.inputs.confrimPassword.current!.value =
        props.inputData.confrimPassword;
    }
    props.inputs.network.current!.value = props.inputData.network;
  };

  useEffect(loadUserDetilsInit, []);

  const onOk = (e: any) => {
    e.preventDefault();
    props.onNext();
  };
  const onEditProfileOk = (e: any) => {

    e.preventDefault();
    if (
      props.validation.password.notStrong ||
      props.validation.confirmPassword.notMacth ||
      props.validation.userName.exist ||
      props.validation.userName.minLength
    ) {

    }
    if (utilService.isWeb()) {
      props.onNext();

    }
  };

  const isFieldValid = () => {
    return !(
      props.validation.firstName.req &&
      props.validation.lastName.req &&
      props.validation.userName.minLength &&
      !props.validation.userName.exist &&
      props.validation.password.notStrong &&
      props.validation.confirmPassword.notMacth
    );
  };

  return (
    <form onSubmit={onOk}>
      <IonGrid className="full-wrapper">
        <IonRow>
          <IonCol>
            <div className="item-input-wrapper">
              <div className="input-icon icon-name"></div>
              <IonItem>
                <IonLabel position="floating">
                  <span className="red-star">*</span> {t("firstName")}
                </IonLabel>
                {props.isDisabled ? (
                  <IonInput
                    maxlength={20}
                    required={true}
                    debounce={500}
                    ref={props.inputs.firstName}
                    onIonChange={props.onFirstName}
                    readonly
                  ></IonInput>
                ) : (
                  <IonInput
                    maxlength={20}
                    required={true}
                    debounce={500}
                    ref={props.inputs.firstName}
                    onIonChange={props.onFirstName}
                  ></IonInput>
                )}
              </IonItem>
              {(props.validation.firstName.isInputed &&
                !props.validation.firstName.req) && (
                  <div className="feedback">{t("firstNameRequired")}</div>
                )}
            </div>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <div className="item-input-wrapper">
              <div className="input-icon icon-name"></div>
              <IonItem>
                <IonLabel position="floating">
                  <span className="red-star">*</span> {t("lastName")}
                </IonLabel>
                {props.isDisabled ? (
                  <IonInput
                    maxlength={20}
                    required={true}
                    debounce={500}
                    onIonChange={props.onLastName}
                    ref={props.inputs.lastName}
                    readonly
                  ></IonInput>
                ) : (
                  <IonInput
                    maxlength={20}
                    required={true}
                    debounce={500}
                    onIonChange={props.onLastName}
                    ref={props.inputs.lastName}
                  ></IonInput>
                )}
              </IonItem>
              {props.validation.lastName.isInputed &&
                !props.validation.lastName.req && (
                  <div className="feedback">{t("lastNameRequired")}</div>
                )}
            </div>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size-lg="12" size="12">
            <div className="item-input-wrapper">
              <div className="input-icon icon-display_name"></div>
              <IonItem>
                <IonLabel position="floating">{t("displayName")} </IonLabel>
                <IonInput
                  maxlength={20}
                  ref={props.inputs.displayName}
                ></IonInput>
              </IonItem>
            </div>
          </IonCol>
          <IonCol size-lg="12" size="12">
            <div className="item-input-wrapper">
              <div className="input-icon icon-username"></div>
              <IonItem>
                <IonLabel position="floating">
                  <span className="red-star">*</span> {t("username")}
                </IonLabel>
                {props.isDisabled ? (
                  <IonInput
                    minlength={6}
                    maxlength={20}
                    debounce={500}
                    required={true}
                    ref={props.inputs.userName}
                    onIonChange={props.onUsername}
                    readonly
                  ></IonInput>
                ) : (
                  <IonInput
                    minlength={6}
                    maxlength={20}
                    debounce={1000}
                    required={true}
                    ref={props.inputs.userName}
                    onIonChange={props.onUsername}
                  ></IonInput>
                )}
              </IonItem>
              {/* {props.validation.userName.isInputed&&!props.validation.userName.req && (
                <div className="feedback">Username is required</div>
              )} */}
              {props.validation.userName.exist && (
                <div className="feedback">{t("usernameExist")}</div>
              )}
              {props.validation.userName.isInputed &&
                !props.validation.userName.minLength && (
                  <div className="feedback">{t("usernameMinLength")}</div>
                )}
            </div>
          </IonCol>
        </IonRow>
        {props.isPasswordActive && (
          <IonRow>
            <IonCol size-lg="6" size="12">
              <div className="item-input-wrapper">
                <div
                  className={`input-icon clickable ${isShowPassword ? "icon-show_password" : "icon-hide_password"
                    }`}
                  onClick={onShowPassword}
                ></div>
                <IonItem>
                  <IonLabel position="floating">
                    <span className="red-star">*</span> {t("password")}
                  </IonLabel>
                  <IonInput
                    debounce={500}
                    onIonChange={props.onPassword}
                    required={true}
                    maxlength={20}
                    minlength={8}
                    type={isShowPassword ? "text" : "password"}
                    ref={props.inputs.password}
                  ></IonInput>
                </IonItem>
                {props.validation.password.req && (
                  <div className="feedback">Password is required</div>
                )}
                {props.validation.password.isInputed &&
                  !props.validation.password.notStrong && (
                    <div className="feedback">
                      Must include 1 digit, 1 alphabet, 1 special character and
                      at least 8 characters long
                    </div>
                  )}
              </div>
            </IonCol>
            <IonCol size-lg="6" size="12">
              <div className="item-input-wrapper">
                <div
                  className={`input-icon clickable ${isShowCrfmPassword
                      ? "icon-show_password"
                      : "icon-hide_password"
                    }`}
                  onClick={onShowCrfmPassword}
                ></div>
                <IonItem>
                  <IonLabel position="floating">
                    <span className="red-star">*</span> {t("confirmPassword")}
                  </IonLabel>
                  <IonInput
                    debounce={500}
                    onIonChange={props.onConfirmPassword}
                    maxlength={20}
                    minlength={8}
                    required={true}
                    type={isShowCrfmPassword ? "text" : "password"}
                    ref={props.inputs.confrimPassword}
                  ></IonInput>
                </IonItem>
                {props.validation.confirmPassword.req && (
                  <div className="feedback"> {t("confirmPasswordRequired")}</div>
                )}
                {props.validation.confirmPassword.isInputed &&
                  !props.validation.confirmPassword.notMacth && (
                    <div className="feedback">Not matching with Password</div>
                  )}
              </div>
            </IonCol>
          </IonRow>
        )}
        <IonRow>
          <IonCol>
            <div className="item-input-wrapper">
              <div className="input-icon icon-network"></div>
              <IonItem>
                <IonLabel position="floating">
                  <span className="red-star">*</span>Network
                </IonLabel>
                <IonInput
                  maxlength={20}
                  debounce={500}
                  required={true}
                  ref={props.inputs.network}
                  onIonChange={props.onNetwork}
                  value={props.inputData.network}
                  readonly
                ></IonInput>
              </IonItem>
            </div>
          </IonCol>
        </IonRow>
        <IonRow className="button-container">
          <IonCol>
            {props.myProfNextBtn ? (
              <IonButton
                onClick={onEditProfileOk}
                className="next-btn button primary-btn btn-curved"
              >
                {t("next")}
              </IonButton>
            ) : (
              <IonButton
                onClick={onOk}
                className="button primary-btn login-btn btn-curved"
                disabled={isFieldValid()}
              >
                {t("next")}
              </IonButton>
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
    </form>
  );
};

export default UserRegistrationInputFirst;
